var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"commonBg"},[_c('div',{staticClass:"page"},[_c('HeaderLayer'),_c('div',{staticClass:"main-layer"},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }